import React, { useEffect, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { IoNotificationsOutline } from "react-icons/io5";
import {
  Avatar,
  Button,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { findEmployeeNotificationAction } from "../../actions/employeeManagmentAction";
import ChatMessage from "./ChatMessage";
import { toast, ToastContainer } from "react-toastify";
import { chatWithCounsilorNotificationAction } from "../../actions/leadChatAction";
import useNotification from "../../constants/customHooks/UseNotification";
import { USER_FIND_SUCCESS } from "../../constants/adminAuthConstant";
import Snackbar from "@mui/material/Snackbar";

const settings = ["Profile","Logout"];

export default function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [notifications, setNotifications] = useState([]);
  // for messages
  const [userMessages, setUserMessages] = useState();

  const [unreadCount, setUnreadCount] = useState(0);
  const [notificationData, setNotificationData] = useState([]);

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorNotification, setAnchorNotification] = useState(null);

  let { loginFindLoading, loginFindSuccess, loginFinderror } = useSelector(
    (state) => {
      return state.findUser;
    }
  );

  const { loginSuccess, loginSubmitLoading, loginSubmiterror } = useSelector(
    (state) => {
      return state.loginSubmit;
    }
  );

  // Response of Chat notification

  let {
    chatWithCounselorNotificationSuccess,
    chatWithCounselorNotificationErr,
  } = useSelector((state) => {
    return state.ChatWithCounsilorNotification;
  });

  const {
    findEmployeeNotificationLoading,
    findEmployeeNotificationSuccess,
    findEmployeeNotificationError,
  } = useSelector((state) => {
    return state.findEmployeeNotification;
  });

  console.log(
    findEmployeeNotificationSuccess,
    "findEmployeeNotificationSuccessfindEmployeeNotificationSuccess"
  );

  useEffect(() => {
    if (chatWithCounselorNotificationSuccess) {
      setUserMessages(chatWithCounselorNotificationSuccess.data);
    }
  }, [chatWithCounselorNotificationSuccess]);

  let { chatWithCounselorStatusChangeSuccess } = useSelector((state) => {
    return state.ChatWithCounsilorStatusChange;
  });

  let { counselorStatusChangeSuccess } = useSelector(
    (state) => state.counsilorNotificationClear
  );

  // socket setup
  const notifications = useNotification();

  // useEffect(() => {

  //   alert("new meesgae")
  //   // <Snackbar
  //   //   // open={open}
  //   //   autoHideDuration={5000}
  //   //   // onClose={handleClose}
  //   //   message="This Snackbar will be dismissed in 5 seconds."
  //   // />
  // }, [notifications]);

  useEffect(() => {
    dispatch(chatWithCounsilorNotificationAction());
  }, [
    dispatch,
    chatWithCounselorStatusChangeSuccess,
    counselorStatusChangeSuccess,
  ]);

  let isUserExist = localStorage.getItem("loginInfo")
    ? JSON.parse(localStorage.getItem("loginInfo"))
    : null;

  useEffect(() => {
    if (isUserExist) {
      dispatch(findEmployeeNotificationAction());
    }
  }, [dispatch, notifications, loginFindSuccess, loginSubmitLoading]);

  useEffect(() => {
    if (findEmployeeNotificationSuccess && isUserExist) {
      setNotificationData(findEmployeeNotificationSuccess?.data);

      // Increase the unread count when a new notification arrives

      let unRead = findEmployeeNotificationSuccess?.data?.filter(
        (item) => item.isOpen == 0 && isUserExist?.UserId == item.userId
      );
      setUnreadCount(unRead.length);
    }
  }, [findEmployeeNotificationSuccess, isUserExist, loginSubmitLoading]);

  // hooks
  useEffect(() => {
    if (!isUserExist) {
      navigate("/login");
    }
  }, [isUserExist, navigate, loginFindSuccess, loginSubmitLoading]);

  // profile handlers
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  // click

  const markAsRead = () => {
    setUnreadCount(0);
    navigate("/notifications");
  };

  const handleLogout = () => {
    localStorage.removeItem("loginInfo");
    dispatch({ type: USER_FIND_SUCCESS, payload: null });
    // navigate("/login");
  };

  const handleProfile = ()=>{
    navigate('/profile')
  }

  const handleNotificationMenu = (event) => {
    setAnchorNotification(event.currentTarget);
  };

  return (
    <>
      {isUserExist ? (
        <>
          <Box
            sx={{
              backgroundColor: "white",
            }}
          >
            <AppBar
              position="static"
              sx={{
                backgroundColor: "#fff",
                height: "68px",
                boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
              }}
              // elevation={1}
            >
              <Toolbar
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Typography
                  noWrap
                  variant="h4"
                  component="a"
                  href="/"
                  sx={{
                    top: "32px",
                    Left: "142px",
                    ml: 12,
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 950,
                    fontSize: "30px",
                    color: "#1F56AE",
                    textDecoration: "none",
                    marginTop: "15px",
                    display: { md: "block", sm: "block", xs: "none" },
                    pl: !props.isHover && "120px",
                    width: "fit-content",
                  }}
                >
                  Global Study Link
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {loginFindSuccess !== null &&
                    loginFindSuccess?.role?.roleName === "counsellor" && (
                      <Box>
                        <Tooltip title="Chat" onClick={handleNotificationMenu}>
                          <IconButton
                            id="notification"
                            sx={{ p: 0, position: "relative" }}
                          >
                            <svg
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.7214 0.71875C2.96194 0.71875 0.734521 2.95663 0.73003 5.72071L0.718757 12.635C0.71441 15.2771 2.76218 17.4143 5.35066 17.6019V21.9217C5.35064 21.9928 5.37172 22.0624 5.41124 22.1215C5.45076 22.1806 5.50693 22.2267 5.57265 22.2539C5.63837 22.2811 5.71068 22.2882 5.78043 22.2743C5.85018 22.2604 5.91423 22.2261 5.96447 22.1757L10.4909 17.638H17.2899C20.0493 17.638 22.2813 15.4 22.2813 12.6354V5.72139C22.2813 2.95772 20.0606 0.71875 17.3012 0.71875H5.7214ZM5.7214 1.43727H17.3012C19.6739 1.43727 21.5623 3.34034 21.5623 5.72139V12.6354C21.5623 15.0152 19.6627 16.9194 17.2899 16.9194H10.342C10.2947 16.9194 10.2478 16.9287 10.2041 16.9469C10.1604 16.9651 10.1207 16.9917 10.0874 17.0253L6.06926 21.0531V17.279C6.06918 17.1838 6.03132 17.0925 5.96399 17.0252C5.89665 16.9578 5.80535 16.92 5.71012 16.9199C3.33736 16.9199 1.43346 15.0157 1.43735 12.6366L1.44863 5.7222C1.45243 3.34157 3.34863 1.43727 5.7214 1.43727ZM7.90637 8.10094C7.3152 8.10094 6.8283 8.58787 6.82831 9.17899C6.82832 9.77011 7.31521 10.257 7.90637 10.257C8.49752 10.257 8.98442 9.77011 8.98443 9.17899C8.98443 8.58787 8.49753 8.10094 7.90637 8.10094ZM11.5 8.10094C10.9088 8.10094 10.4219 8.58787 10.4219 9.17899C10.422 9.77011 10.9088 10.257 11.5 10.257C12.0912 10.257 12.5781 9.77011 12.5781 9.17899C12.5781 8.58787 12.0912 8.10094 11.5 8.10094ZM15.094 8.10094C14.5028 8.10094 14.0156 8.58787 14.0156 9.17899C14.0156 9.77011 14.5028 10.257 15.094 10.257C15.6851 10.257 16.172 9.77011 16.172 9.17899C16.172 8.58787 15.6851 8.10094 15.094 8.10094ZM7.90637 8.81987C8.10912 8.81987 8.26583 8.97634 8.26583 9.17899C8.26583 9.38165 8.10911 9.53839 7.90637 9.53839C7.70362 9.53839 7.54691 9.38165 7.5469 9.17899C7.5469 8.97634 7.70362 8.81987 7.90637 8.81987ZM11.5 8.81987C11.7028 8.81987 11.8591 8.97634 11.8591 9.17899C11.8591 9.38165 11.7028 9.53839 11.5 9.53839C11.2973 9.53839 11.1405 9.38165 11.1405 9.17899C11.1405 8.97634 11.2973 8.81987 11.5 8.81987ZM15.094 8.81987C15.2967 8.81987 15.4531 8.97634 15.4531 9.17899C15.4531 9.38165 15.2967 9.53839 15.094 9.53839C14.8912 9.53839 14.7345 9.38165 14.7345 9.17899C14.7345 8.97634 14.8912 8.81987 15.094 8.81987Z"
                                fill="#ACB1C6"
                                stroke="#ACB1C6"
                                stroke-width="0.766667"
                              />
                            </svg>
                            {/* <Typography
                        sx={{
                          width: "18px",
                          height: "18px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          backgroundColor: "rgba(119, 122, 174, 1)",
                          position: "absolute",
                          top: 0,
                          right: "0px",
                          color: "#fff",
                          fontSize: "8px",
                        }}
                      >
                        2
                      </Typography> */}
                          </IconButton>
                        </Tooltip>
                        <Box>
                          <Menu
                            sx={{
                              mt: "45px",
                              width: "100%",
                              "& .MuiPaper-root": {
                                borderRadius: "16px",
                                overflow: "hidden",
                                width: "100%",
                                maxWidth: "530px",
                              },
                              "& ul": {
                                padding: "0px !important",
                              },
                            }}
                            id="notification"
                            anchorEl={anchorNotification}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            open={Boolean(anchorNotification)}
                            onClose={() => setAnchorNotification(false)}
                          >
                            <Box
                              sx={{
                                padding: "20px 24px !important",
                                border: "1px solid #ECECEC",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "18px",
                                  lineHeight: "26px",
                                  color: "#141E3C",
                                  fontWeight: "700",
                                }}
                              >
                                Messages
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                maxHeight: "537px",
                                height: "100%",
                                overflowY: "scroll",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "grid",
                                  gap: "20px",
                                  padding: "20px",
                                  "& div": {
                                    boxSizing: "border-box",
                                  },
                                }}
                              >
                                {userMessages?.length > 0 ? (
                                  userMessages?.map((item, i) => (
                                    <ChatMessage
                                      image={item?.image}
                                      name={`${item?.userName} send a message`}
                                      time={item.time}
                                      status={item.isOpen}
                                      senderId={item.senderId}
                                      messageId={item._id}
                                    />
                                  ))
                                ) : (
                                  <Typography>No new messages</Typography>
                                )}
                              </Box>
                            </Box>
                          </Menu>
                        </Box>
                      </Box>
                    )}

                  {unreadCount === 0 ? (
                    <Icon
                      sx={{
                        color: "#ACB1C6",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => navigate("/notifications")}
                    >
                      <IoNotificationsOutline size={25} />
                    </Icon>
                  ) : (
                    <Box
                      sx={{ position: "relative", cursor: "pointer" }}
                      onClick={markAsRead}
                    >
                      {}
                      <Icon sx={{ color: "#ACB1C6" }}>
                        <IoNotificationsOutline size={25} />
                      </Icon>
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "-5px",
                          right: "-10px",
                          background: "red",
                          color: "white",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "14px", // Adjust the font size
                          fontWeight: "bold",
                        }}
                      >
                        {unreadCount}
                        {/* Replace with the actual notification count */}
                      </Box>
                    </Box>
                  )}

                  <Box>
                    <Tooltip title="Open settings">
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        <Avatar
                          alt="Remy Sharp"
                          src={
                            loginFindSuccess !== null &&
                            loginFindSuccess?.img_url
                              ? loginFindSuccess.img_url
                              : "/static/images/avatar/2.jpg"
                          }
                        />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >
                      {settings.map((setting) => (
                        <MenuItem key={setting} onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={setting === "Logout" && handleLogout || setting == "Profile" && handleProfile}
                          >
                            {setting}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                </Box>
              </Toolbar>
            </AppBar>
          </Box>
        </>
      ) : null}
    </>
  );
}
